export enum DesignationTypesEnum {
    Director = 1,
    HRExecutive = 2,
    ProjectManager = 3,
    TeamLeader = 4,
    BDM = 5,
    BDE = 6,
    FrontEndDeveloper = 7,
    SrFrontEndDeveloper = 8,
    BackEndDeveloper = 9,
    SrBackEndDeveloper = 10,
    FullStackDeveloper = 11,
    SrFullStackDeveloper = 12,
    MobileDeveloper = 13,
    SrMobileDeveloper = 14,
    UIUXDesigner = 15,
    WebDesigner = 16,
    SrWebDesigner = 17,
    SoftwareEngineer = 18,
    PHPDeveloper = 19,
    SrPHPDeveloper = 20,
    Trainee = 21,
    ProjectTrainee = 22,
    CTO = 23,
    SrSoftwareDeveloper = 24,
    SoftwareDeveloper = 25,
    SrHRExecutive = 26,
    WebDeveloper = 27,
    SrWebDeveloper = 28,
}

export enum DesignationTypesNameEnum {
    Director = "Director",
    HRExecutive = "HRExecutive",
    ProjectManager = "Project Manager",
    TeamLeader = "Team Leader",
    BDM = "BDM",
    BDE = "BDE",
    FrontEndDeveloper = "FrontEnd Developer",
    SrFrontEndDeveloper = "Sr. FrontEnd Developer",
    BackEndDeveloper = "BackEnd Developer",
    SrBackEndDeveloper = "Sr. BackEnd Developer",
    FullStackDeveloper = "FullStack Developer",
    SrFullStackDeveloper = "Sr. FullStack Developer",
    MobileDeveloper = "Mobile Developer",
    SrMobileDeveloper = "Sr.Mobile Developer",
    UIUXDesigner = "UI / UX Designer",
    WebDesigner = "Web Designer",
    SrWebDesigner = "Sr. Web Designer",
    SoftwareEngineer = "Software Engineer",
    PHPDeveloper = "PHP Developer",
    SrPHPDeveloper = "Sr. PHP Developer",
    Trainee = "Trainee",
    ProjectTrainee = "Project Trainee",
    CTO = "Chief Technology Officer",
    SrSoftwareDeveloper = "Sr. Software Developer",
    SoftwareDeveloper = "Software Developer",
    SrHRExecutive = "Sr. HRExecutive",
    WebDeveloper = "Web Developer",
    SrWebDeveloper = "Sr. Web Developer",
}